
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.063.5a.555.555 0 00-.563.563V5H2.437c-.421 0-.632.516-.328.82l3.563 3.563a.468.468 0 00.633 0L9.867 5.82c.305-.304.094-.82-.328-.82H7.5V1.062A.57.57 0 006.937.5H5.063zM12 9.313a.57.57 0 00-.563-.563H7.992L6.844 9.898a1.176 1.176 0 01-1.711 0L3.984 8.75H.563A.555.555 0 000 9.313v2.624c0 .329.234.563.563.563h10.874a.555.555 0 00.563-.563V9.313zm-2.906 2.062a.47.47 0 01-.469.469.47.47 0 01-.469-.469.47.47 0 01.469-.469.47.47 0 01.469.469zm1.5 0a.47.47 0 01-.469.469.47.47 0 01-.469-.469.47.47 0 01.469-.469.47.47 0 01.469.469z"}})])
          )
        }
      }
    